import { Paginator } from "primereact/paginator";
import React, { useEffect } from "react";
import { connect } from "react-redux";
import { updatePagination } from "Redux/Actions/paginationActions";
import "./Pagination.scss";
import PropTypes from "prop-types";

const TempPagination = (props) => {
  const onBasicPageChange = (event) => {
    props.handleUpdatePagination({ currentPage: event.page + 1 });
    props.handleUpdatePagination({ paginationBasicFirst: event.first });
    props.handleUpdatePagination({ paginationBasicRows: event.rows });
    props.result.setPage(event.page + 1);
    if (props.pagination.currentPage !== 1) {
      window.scroll({
        top: props.refItemParent.current.offsetTop,
        behavior: "smooth",
      });
    }
  };

  useEffect(() => {
    if (props.pagination.paginationBasicFirst > 0) {
      window.scroll({
        top: props.refItemParent.current.offsetTop,
        behavior: "smooth",
      });
    }
  }, [props.pagination.paginationBasicFirst]);

  return (
    <div className="pagination">
      {props.result && props.result.loaded ? (
        <Paginator
          first={props.pagination.paginationBasicFirst}
          pageLinkSize={screen.width <= 830 ? 1 : 3}
          data={props.result.data}
          rows={props.rows || props.pagination.paginationBasicRows}
          totalRecords={props.result.totalItems || 0}
          leftContent={"Page précédente"}
          rightContent={"Page suivante"}
          onPageChange={onBasicPageChange}
        />
      ) : (
        <Paginator />
      )}
    </div>
  );
};

TempPagination.propTypes = {
  auth: PropTypes.object,
  rows: PropTypes.number,
  url: PropTypes.string,
  params: PropTypes.object,
  result: PropTypes.object,
  handleUpdatePagination: PropTypes.func,
  pagination: PropTypes.any,
  refItemParent: PropTypes.object,
};
const mapStateToProps = (state) => ({
  auth: state.auth,
  items: state.items,
  pagination: state.pagination,
});

const mapDispatchToProps = (dispatch) => ({
  handleUpdatePagination: (value) => dispatch(updatePagination(value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TempPagination);
